import React from 'react';
import classNames from 'classnames';

class Table extends React.Component {
    render() {
        let classes = {
            centered: this.props.centered,
            highlight: this.props.hoverable,
            'responsive-table': this.props.responsive,
            striped: this.props.striped,
            bordered: this.props.bordered
        };

        let {className, children, ...props} = this.props;

        return (
            <table className={classNames(classes, className)} {...props}>
                {children}
            </table>
        );
    }
}

Table.propTypes = {
    /**
     * Center align all the text in the table
     * @default false
     */
    centered: React.PropTypes.bool,
    /**
     * Highlight the row that's hovered
     * @default false
     */
    hoverable: React.PropTypes.bool,
    /**
     * Enable response to make the table horizontally scrollable on smaller screens
     * @default false
     */
    responsive: React.PropTypes.bool,
    /**
     * Striped style
     * @default false
     */
    striped: React.PropTypes.bool,
    /**
     * Add border to each row
     * @default false
     */
    bordered: React.PropTypes.bool,

    className: React.PropTypes.string,
    children: React.PropTypes.node
};


export default Table;